import Backbone from 'backbone'
import _ from 'lodash'
import FormView from 'scoreboard/components/form-view'
import i18n from 'scoreboard/components/i18n'
import LabeledToggle from 'scoreboard/components/labeled-toggle'
import template from './total-container-value-setting.hbs'
const AUTO = 'auto'
const CONSTANT = 'constant'

/**
 * Displays a selector for an automatic container value or a constant value. For
 * use with waffle charts
 */
const TotalContainerValueSetting = Backbone.View.extend({
	tagName: 'form',

	className: 'total-container-value-setting',

	/**
	 * @type ChartDesigner
	 */
	chartDesigner: null,

	/**
	 * @param {ChartDesigner} [options.chartDesigner]
	 * @param {Object} [options.setting]
	 */
	initialize: function(options) {
		this.chartDesigner = options.chartDesigner
		this.setting = _.clone(options.setting)
		// We know the value of the toggle based on whether the passed in setting
		// is null or not
		this.toggleValue = this.setting ? CONSTANT : AUTO

		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this),
			test: () => this.test()
		})
	},

	render: function() {
		this.$el.empty().append(template({}))
		this.renderToggle()
		this.$('input[name="number"]').val(this.setting)
		this.formView.start()
		return this
	},

	renderToggle: function() {
		this.toggle = new LabeledToggle({ options: [
			{
				label: 'charts.forecast.model.auto',
				value: AUTO
			},
			{
				label: 'charts.chart.constantNumber',
				value: CONSTANT
			}
		]})

		this.$('.toggle-container').append(this.toggle.el)
		this.toggle.render()
		this.toggle.val(this.toggleValue, { silent: false })
		this.toggle.on('change', this.onToggleChanged.bind(this))
		this.onToggleChanged(this.toggleValue)
	},

	onToggleChanged: function(toggleVal) {
		this.formView.change()
		this.toggleValue = toggleVal
		this.$('.number-container').toggleClass('is-not-displayed', toggleVal === AUTO)
	},

	test: function() {
		if (this.toggleValue === CONSTANT && !this.$('input[name="number"]').val()) {
			// A value must be entered in the input when "Constant Number" is selected
			return i18n.get('charts.chart.constantNumberRequired')
		}
	},

	submit: function() {
		this.setting = this.toggleValue === AUTO ? null :
			this.$('input[name="number"]').val()

		this.trigger('done', this.setting)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.toggle], 'remove')
	}
})

export default TotalContainerValueSetting
TotalContainerValueSetting.__filename__ = 'charts/edit/total-container-value-setting.js'
